import { useAppDispatch, useAppSelector } from '@/redux/global-hooks';
import {
  selectWheel,
  setWheel as _setWheel,
  clearWheel as _clearWheel,
} from '@/redux/slices/wheel.slice';

export default function useWheel() {
  const dispatch = useAppDispatch();
  const tile = useAppSelector(selectWheel);

  const setWheel = (value) => dispatch(_setWheel(value));
  const clearWheel = () => dispatch(_clearWheel());

  return {
    tile,
    setWheel,
    clearWheel,
  };
}
